import * as React from 'react';
import styled from 'styled-components';
import { COLORS } from 'styles/colors';
import { Radio } from '.';

const SErrorMessage = styled.span`
    color: ${COLORS.RED};
    margin: 5px 0;
`;
const SLabel = styled.span`
    display: block;
    margin-bottom: .5rem;
    font-size: .9em;
`;
interface Ilist{
    label: string;
    value: string| number;
    name: string;
}
interface IInput {
    id?:string;
    list: Ilist[];
    label: string;
    value?: string | number;
    className?: string;
    onChange?: (e:any) => void;
    hasError?: boolean;
    error?: string;
}
interface IState{
    list: any[],
    currValue: any
}

export class RadioButtonList extends React.Component<IInput, IState> {
    constructor(props:IInput){
        super(props);
        this.state = {
            list: [],
            currValue: -1
        }
    }
    public componentDidMount = () => {
        if(this.props.value && typeof this.props.value === 'number'){
            this.setState({
               currValue: Number(this.props.value)
            })
        }else{
            this.setState({
               currValue: this.props.value
            })
        }
    }
    public componentDidUpdate = (props:any) => {
        if(this.props.value !== props.value){
            if(this.props.value && typeof this.props.value === 'number'){
                this.setState({
                currValue: Number(this.props.value)
                })
            }else{
                this.setState({
                currValue: this.props.value
                })
            }
        }
    }
    public onGroupChange = (e:any) => {
        if(this.props.onChange){
            const val:any = typeof this.props.value === 'number'? Number(e.currentTarget.value):e.currentTarget.value;
            this.props.onChange(val)
        }
    }
    public render(){
        return ( 
            <div className={this.props.className? this.props.className: 'col-30'}>
                <div className="form-group" id={`radiogroup-${this.props.id}`}>
                    <SLabel>{this.props.label}</SLabel>
                    {this.props.list.map((radio:any) =>{
                        return <Radio className={this.props.className?this.props.className:''} 
                        key={`${radio.name}-${radio.value}`} 
                        id={`${radio.name}-${radio.value}`} 
                        name={radio.name} 
                        value={radio.value} 
                        isDisabled={radio.isDisabled} 
                        label={radio.label} isSelected={this.state.currValue === radio.value? true: false}
                        onChange={this.onGroupChange} />
                    })}
                    <SLabel>{this.props.hasError && this.props.error && <SErrorMessage>{this.props.error}</SErrorMessage>}</SLabel>
                </div>
            </div>
        );
    }
};
